import "../App.css";
import "../CSS/LoginPage.css";
import {LoginForm} from '../components/indexComponents';



function LoginPage() {
  return (
    <div className="App loginPage">
      <LoginForm />
    </div>
  );
}

export default LoginPage;